import { createApp } from "vue";
import { createWebHistory, createRouter } from "vue-router";

// Element Plus
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import zhCn from 'element-plus/dist/locale/zh-cn.mjs'

// 配置 Element Plus 中文语言
const app = createApp(App)
app.use(ElementPlus, { locale: zhCn })
installLuckdrawApi(app)

// styles

import "@fortawesome/fontawesome-free/css/all.min.css";
import "@/assets/styles/tailwind.css";

// mouting point for the whole app

import App from "@/App.vue";

// layouts

import Admin from "@/layouts/Admin.vue";
import Auth from "@/layouts/Auth.vue";

// views for Admin layout

import Dashboard from "@/views/admin/Dashboard.vue";
import Settings from "@/views/admin/Settings.vue";
import Tables from "@/views/admin/Tables.vue";
import Maps from "@/views/admin/Maps.vue";
import Rbac from "@/views/admin/Rbac.vue";

// views for Auth layout

import Login from "@/views/auth/Login.vue";
import Register from "@/views/auth/Register.vue";
import WxAuth from "@/views/auth/WxAuth.vue";

// views without layouts

import Landing from "@/views/Landing.vue";
import Profile from "@/views/Profile.vue";
import Home from "@/views/Home.vue";

// 导入认证工具
import { getUserInfo, isUserLoggedIn } from "@/utils/auth.js";
import { installAuthFetchInterceptor } from "@/utils/authFetchInterceptor.js";
import { installLuckdrawApi } from "@/api/luckdraw.js";
import {
  MENU_PERMISSION_KEYS,
  canAccessRoute,
  getFirstAccessibleAdminPath,
} from "@/utils/rbac.js";

// 导入客户管理相关组件
import Verification from "@/views/admin/customers/Verification.vue";
import VerificationDetail from "@/views/admin/customers/VerificationDetail.vue";
import Complaints from "@/views/admin/customers/Complaints.vue";
import Users from "@/views/admin/customers/Users.vue";
import AwardRiskWhitelist from "@/views/admin/customers/AwardRiskWhitelist.vue";
import Authority from "@/views/admin/customers/Authority.vue";
import Activities from "@/views/admin/customers/Activities.vue";

// 导入订单管理相关组件
import PaymentOrders from "@/views/admin/orders/PaymentOrders.vue";

// 导入运营素材管理相关组件
import PrizePictureList from "@/views/admin/materials/PrizePictureList.vue";
import MaterialLibrary from "@/views/admin/materials/MaterialLibrary.vue";
import TemplateList from "@/views/admin/materials/TemplateList.vue";
import HomeBanner from "@/views/admin/materials/HomeBanner.vue";

// 导入官方每日福利相关组件
import WelfareSchedule from "@/views/admin/welfare/Schedule.vue";
import WelfareGoods from "@/views/admin/welfare/Goods.vue";
import WelfareSponsors from "@/views/admin/welfare/Sponsors.vue";

// 导入监控相关组件
import CreateAbandon from "@/views/admin/monitor/CreateAbandon.vue";
import CreateDashboard from "@/views/admin/monitor/CreateDashboard.vue";
import TaskImageAudit from "@/views/admin/monitor/TaskImageAudit.vue";

// routes

const routes = [
  {
    path: "/admin",
    redirect: "/admin/dashboard",
    component: Admin,
    meta: { requiresAuth: true }, // 需要登录验证
    children: [
      {
        path: "/admin/dashboard",
        component: Dashboard,
        meta: { requiresAuth: true, permissionKey: MENU_PERMISSION_KEYS.DASHBOARD },
      },
      {
        path: "/admin/settings",
        component: Settings,
        meta: { requiresAuth: true },
      },
      {
        path: "/admin/tables",
        component: Tables,
        meta: { requiresAuth: true },
      },
      {
        path: "/admin/maps",
        component: Maps,
        meta: { requiresAuth: true },
      },
      // 客户管理
      {
        path: "/admin/customers/users",
        component: Users,
        meta: { requiresAuth: true, permissionKey: MENU_PERMISSION_KEYS.CUSTOMERS_USERS },
      },
      {
        path: "/admin/customers/award-risk-whitelist",
        component: AwardRiskWhitelist,
        meta: { requiresAuth: true, permissionKey: MENU_PERMISSION_KEYS.CUSTOMERS_AWARD_RISK_WHITELIST },
      },
      {
        path: "/admin/customers/authority/:uid",
        component: Authority,
        meta: { requiresAuth: true, permissionKey: MENU_PERMISSION_KEYS.CUSTOMERS_USERS },
      },
      {
        path: "/admin/customers/activities",
        component: Activities,
        meta: { requiresAuth: true, permissionKey: MENU_PERMISSION_KEYS.CUSTOMERS_ACTIVITIES },
      },
      {
        path: "/admin/activities/recommendations",
        component: Activities,
        meta: { requiresAuth: true, permissionKey: MENU_PERMISSION_KEYS.ACTIVITIES_RECOMMENDATIONS },
      },
      {
        path: "/admin/customers/verification",
        component: Verification,
        meta: { requiresAuth: true, permissionKey: MENU_PERMISSION_KEYS.CUSTOMERS_VERIFICATION },
      },
      {
        path: "/admin/customers/verification/:id",
        component: VerificationDetail,
        meta: { requiresAuth: true, permissionKey: MENU_PERMISSION_KEYS.CUSTOMERS_VERIFICATION },
      },
      {
        path: "/admin/customers/complaints",
        component: Complaints,
        meta: { requiresAuth: true, permissionKey: MENU_PERMISSION_KEYS.CUSTOMERS_COMPLAINTS },
      },
      // 订单
      {
        path: "/admin/orders/online-payment",
        component: PaymentOrders,
        meta: { requiresAuth: true, permissionKey: MENU_PERMISSION_KEYS.ORDERS_ONLINE_PAYMENT },
      },
      // 运营素材管理
      {
        path: "/admin/materials/images",
        component: PrizePictureList,
        meta: { requiresAuth: true, permissionKey: MENU_PERMISSION_KEYS.MATERIALS_IMAGES },
      },
      {
        path: "/admin/materials/library",
        component: MaterialLibrary,
        meta: { requiresAuth: true, permissionKey: MENU_PERMISSION_KEYS.MATERIALS_LIBRARY },
      },
      {
        path: "/admin/materials/templates",
        component: TemplateList,
        meta: { requiresAuth: true, permissionKey: MENU_PERMISSION_KEYS.MATERIALS_TEMPLATES },
      },
      {
        path: "/admin/materials/home-banner",
        component: HomeBanner,
        meta: { requiresAuth: true, permissionKey: MENU_PERMISSION_KEYS.MATERIALS_HOME_BANNER },
      },
      {
        path: "/admin/materials/pc-cms",
        redirect: "/admin/cms/articles",
      },
      // CMS
      {
        path: "/admin/cms/menus",
        component: HomeBanner,
        meta: { requiresAuth: true, permissionKey: MENU_PERMISSION_KEYS.CMS_MENU_LIST },
      },
      {
        path: "/admin/cms/articles",
        component: HomeBanner,
        meta: { requiresAuth: true, permissionKey: MENU_PERMISSION_KEYS.CMS_ARTICLE_LIST },
      },
      // 官方每日福利
      {
        path: "/admin/welfare/schedule",
        component: WelfareSchedule,
        meta: { requiresAuth: true, permissionKey: MENU_PERMISSION_KEYS.WELFARE_SCHEDULE },
      },
      {
        path: "/admin/welfare/products",
        component: WelfareGoods,
        meta: { requiresAuth: true, permissionKey: MENU_PERMISSION_KEYS.WELFARE_PRODUCTS },
      },
      {
        path: "/admin/welfare/sponsors",
        component: WelfareSponsors,
        meta: { requiresAuth: true, permissionKey: MENU_PERMISSION_KEYS.WELFARE_SPONSORS },
      },
      // 活动创建监控
      {
        path: "/admin/monitor/create-dashboard",
        component: CreateDashboard,
        meta: { requiresAuth: true, permissionKey: MENU_PERMISSION_KEYS.MONITOR_CREATE_DASHBOARD },
      },
      {
        path: "/admin/monitor/abandon",
        component: CreateAbandon,
        meta: { requiresAuth: true, permissionKey: MENU_PERMISSION_KEYS.MONITOR_ABANDON },
      },
      {
        path: "/admin/monitor/image-audit",
        component: TaskImageAudit,
        meta: { requiresAuth: true, permissionKey: MENU_PERMISSION_KEYS.MONITOR_IMAGE_AUDIT },
      },
      {
        path: "/admin/rbac",
        component: Rbac,
        meta: { requiresAuth: true, permissionKey: MENU_PERMISSION_KEYS.RBAC },
      },
    ],
  },
  {
    path: "/auth",
    redirect: "/auth/login",
    component: Auth,
    children: [
      {
        path: "/auth/login",
        component: Login,
      },
      {
        path: "/auth/register",
        component: Register,
      },
      {
        path: "/auth/wxauth",
        component: WxAuth,
      },
    ],
  },
  {
    path: "/landing",
    component: Landing,
  },
  {
    path: "/profile",
    component: Profile,
    meta: { requiresAuth: true },
  },
  {
    path: "/",
    component: Home,
  },
  { path: "/:pathMatch(.*)*", redirect: "/" },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

installAuthFetchInterceptor();

// 路由守卫 - 检查用户是否已登录
router.beforeEach((to, from, next) => {
  // 检查路由是否需要登录验证
  if (to.matched.some(record => record.meta.requiresAuth)) {
    // 检查用户是否已登录
    const isLoggedIn = isUserLoggedIn();

    if (!isLoggedIn) {
      // 未登录，重定向到首页（首页会显示登录界面）
      next('/');
    } else {
      const permissionKey = to.matched.find(record => record.meta.permissionKey)?.meta.permissionKey;
      const userInfo = getUserInfo();

      if (permissionKey && !canAccessRoute(userInfo, permissionKey)) {
        next(getFirstAccessibleAdminPath(userInfo));
        return;
      }

      // 已登录且有权限，允许访问
      next();
    }
  } else {
    // 不需要登录验证的路由，直接允许访问
    next();
  }
});

app.use(router).mount("#app");
